import { Link } from "react-router-dom";
import { formatPrice, formatViews, isDoramaFree } from "../lib/catalog";
import type { Dorama } from "../types";

export function DoramaCard({ dorama, onPreview }: { dorama: Dorama; onPreview?: (dorama: Dorama) => void }) {
  const target = `/dorama/${dorama.slug || dorama.id}`;
  const isFree = isDoramaFree(dorama.free_until);

  const content = (
    <>
      <div className="poster-wrap">
        {dorama.cover_url ? (
          <img src={dorama.cover_url} alt={`Capa de ${dorama.title}`} loading="lazy" />
        ) : (
          <div className="poster-placeholder">Sem capa</div>
        )}
        <div className="card-language-badges">
          {dorama.has_dubbing && <span className="dub-badge">DUB</span>}
          {dorama.has_subtitles && <span className="sub-badge">LEG</span>}
        </div>
        <span className={isFree ? "free-chip" : "price-chip"}>{isFree ? "♛ GRÁTIS" : formatPrice(dorama.price)}</span>
        {onPreview && <span className="card-play" aria-hidden="true"><svg viewBox="0 0 24 24"><polygon points="6 3 20 12 6 21 6 3" /></svg></span>}
      </div>
      <h3>{dorama.title}</h3>
      <p className="card-views"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2.06 12.35a1 1 0 0 1 0-.7 10.75 10.75 0 0 1 19.88 0 1 1 0 0 1 0 .7 10.75 10.75 0 0 1-19.88 0Z"/><circle cx="12" cy="12" r="3"/></svg><span>{formatViews(dorama)}</span><span>visualizações</span></p>
    </>
  );

  return (
    <article className="dorama-card">
      {onPreview ? (
        <button className="dorama-card-button" type="button" onClick={() => onPreview(dorama)} aria-label={`Abrir prévia de ${dorama.title}`}>{content}</button>
      ) : (
        <Link to={target} aria-label={`Ver detalhes de ${dorama.title}`}>{content}</Link>
      )}
    </article>
  );
}
